import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUndoUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowUndoUp"><Path d="M4.81089 8.25L8.06077 5.00011L7.00011 3.93945L1.93945 9.00011L7.00011 14.0608L8.06077 13.0001L4.81066 9.75H20.5V17.5H11V19H22V8.25H4.81089Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowUndoUp;
